// CartItem.js
import React from "react";
import { BiMinus, BiPlus } from "react-icons/bi";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { decrementCartItem, incrementCartItem } from "../context/actions/cartActions";
import { updateCartItemQuantity, updateCartItemQuantityStaff } from "../api";

const CartItem = ({ item, orderNumber }) => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);

  const increaseQuantity = async () => {
    const updatedQuantity = item.quantity + 1;
    dispatch(incrementCartItem(item.productId));
    if (user?.role === "Staff") {
      await updateCartItemQuantityStaff(user.user_id, item.productId, updatedQuantity, orderNumber)
    } else {
      await updateCartItemQuantity(user.user_id, item.productId, updatedQuantity);
    }
  };

  const decreaseQuantity = async () => {
    if (item.quantity > 1) {
      const updatedQuantity = item.quantity - 1;
      dispatch(decrementCartItem(item.productId));
      if (user?.role === "Staff") {
        await updateCartItemQuantityStaff(user.user_id, item.productId, updatedQuantity, orderNumber)
      } else {
        await updateCartItemQuantity(user.user_id, item.productId, updatedQuantity);
      }
    } else if (item.quantity === 1) {
      dispatch(decrementCartItem(item.productId));
      if (user?.role === "Staff") {
        await updateCartItemQuantityStaff(user.user_id, item.productId, 0, orderNumber)
      } else {
        await updateCartItemQuantity(user.user_id, item.productId, 0);
      }
    }
  };

  if (item.quantity > 0) {
    return (
      <div className="w-full p-1 px-2 rounded-lg bg-cartItem flex items-center gap-2">
        <img
          src={item?.imageURL}
          className="w-20 h-20 max-w-[60px] rounded-full object-contain"
          alt=""
        />

        <div className="flex flex-col gap-2">
          <p className="text-base text-gray-50">{item?.product_name}</p>
          <p className="text-sm block text-gray-300 font-semibold">
            {item.quantity} x {parseFloat((parseFloat(item?.product_price))).toLocaleString('en-US')} đ
          </p>
        </div>

        <div className="group flex items-center gap-2 ml-auto cursor-pointer">
          <motion.div whileTap={{ scale: 0.75 }} onClick={decreaseQuantity}>
            <BiMinus className="text-gray-50" />
          </motion.div>

          <p className="w-5 h-5 rounded-sm bg-cartBg text-gray-50 flex items-center justify-center">
            {item.quantity}
          </p>

          <motion.div whileTap={{ scale: 0.75 }} onClick={increaseQuantity}>
            <BiPlus className="text-gray-50" />
          </motion.div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default CartItem;
